import { Injectable } from '@angular/core';
import { PostmethodService } from '../app-config/postmethod.service';
import { environment } from '../../environments/environment';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  constructor(private ws: PostmethodService) { }


  createMaster(request: any) {
    return this.ws.wsPost(request, environment.masterUrl + "getCityMaster");
  }

  allowNumbersOnly(event: any) {
    var inp = String.fromCharCode(event.keyCode);
    if (/[0-9]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  allowAlphabetsOnly(event: any) {
    var inp = String.fromCharCode(event.keyCode);
    if (/[a-zA-Z\s]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  allowAlphabetsSplcharsOnly(event: any) {
    var inp = String.fromCharCode(event.keyCode);
    if (/[a-zA-Z\s!@#$%^&*(),.?":{}|<>]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  allowAlphabetsAndNumbers(event: any) {
    const inp = String.fromCharCode(event.keyCode || event.which);
    if (/^[a-zA-Z0-9\s]+$/.test(inp)) {
      return true; // Allow alphabets, numbers, and spaces
    } else {
      event.preventDefault(); // Prevent invalid characters
      return false;
    }
  }

  private secretKey = 'A0123456789Z';

  encryptData(data: string): string {
    return CryptoJS.AES.encrypt(data, this.secretKey).toString();
  }

  decryptData(encryptedData: string): string {
    const bytes = CryptoJS.AES.decrypt(encryptedData, this.secretKey);
    return bytes.toString(CryptoJS.enc.Utf8);
  }

  setSessionStorage(key: string, value: string): void {
    const encryptedValue = this.encryptData(value);
    sessionStorage.setItem(key, encryptedValue);
  }

  getSessionStorage(key: string): string | null {
    const encryptedValue = sessionStorage.getItem(key);
    return encryptedValue ? this.decryptData(encryptedValue) : null;
  }
}
